import { FunctionComponent, useState, useEffect } from 'react';
import './index.scss';

import _ from 'lodash';
import { Modal, Button } from 'antd';
import { Row, Col, Card, Image } from 'antd';
import {
  FilePdfFilled,
  FilePptFilled,
  FileTextFilled,
  VideoCameraFilled,
  LayoutFilled,
  CloseOutlined,
} from '@ant-design/icons';


interface NewsProps {
  item: any;
  textIdx: number;
}

const News: FunctionComponent<NewsProps> = (props) => {
  const { item, textIdx } = props

  return (
    <div key={item.title} className='news-wrapper'>
      <div className='news-teaser' onClick={() => {
        window.open(item.newsLink, '_blank');
      }}>
        <div className='back-div'>
          <img className='news-image' src={item.img} alt={item.title} />
        </div>
      </div>
      <div className="photo-info">
        <div className="left">
          <div className='year'>
            {item.mediaType} / {item.date}
          </div>
          <div className="title" onClick={() => {
                                  window.open(item.newsLink, '_blank');
                                }}>
            {item.title}
          </div>
          <div className="description">{item.description}</div>
        </div>
        {/* <div className="right">
          <div className="title">{item.title}</div>
          <div className="year">{item.year}</div>
        </div> */}
      </div>
    </div>
  )
}

export default News